//import Trash from 'assets/icons/Trash';
import Button from 'common/components/Button';
import Loader from 'common/components/Loader';
import { isNull } from 'lodash';
import React from 'react';
import { useIntegrationSettings } from 'settings/contexts/IntegrationSettingsContext';

import { IntegrationStatus } from './IntegrationCard';
import IntegrationStatusBadge from './IntegrationStatusBadge';

const SAPSFIntegrationActionsAndStatus = () => {
  const {
    handleSynchronize,
    isSyncingIntegration,
    companyDetail,
    selectedIntegration,
    t,
  } = useIntegrationSettings();

  const showStatusBadge =
    companyDetail?.active_integration === 'SAPSF' ||
    isNull(companyDetail?.active_integration);

  return (
    <div className='flex flex-col gap-2 items-end'>
      <div className='flex items-center gap-2'>
        {/* <Button
          type='button'
          variant='secondary'
          onClick={() => setIsDisableSyncModalOpen(true)}
          disabled={
            isSyncingIntegration ||
            !(companyDetail?.active_integration_status === 'SYNCED')
          }
        >
          <Trash size={16} />
        </Button> */}
        <Button
          type='button'
          variant='secondary'
          onClick={handleSynchronize}
          disabled={isSyncingIntegration}
        >
          {t('synchronize')}
        </Button>
      </div>
      {showStatusBadge ? (
        <IntegrationStatusBadge
          integration={companyDetail}
          activeIntegration={selectedIntegration?.slug}
          i18n={t}
          t={t}
        />
      ) : (
        <IntegrationStatus integration={selectedIntegration} />
      )}
      {isSyncingIntegration ? <Loader size='small' /> : null}
    </div>
  );
};

export default SAPSFIntegrationActionsAndStatus;
